/**
 * This file has the route details defined and it can be used across all the components.
 * We can import the file like 'import RouteList from 'ui.frontend\src\utils\Routes.ts';'
 * Use the value as 'RouteList.login.path'
 */

import { CssPageConfig, RoutesConfig } from './Interfaces/Routes.interface';

const msaprofilePath = '/msaprofile';
const walletFullPath = `${msaprofilePath}/wallet`;
const oneStoreWalletFullPath = `${msaprofilePath}/myrealms`;
const oneStoreRedeemFullPath = `${msaprofilePath}/redeem-code`;

const defaultCssPageConfig: CssPageConfig = {
  pageBackgroundColor: 'black',
  breadcrumbs: true
};

export const RouteList: RoutesConfig = {
  login: {
    name: 'Login',
    path: '/login',
    fullPath: '/login',
    cssRouteConfig: defaultCssPageConfig
  },
  msaProfile: {
    name: 'MSAProfile',
    path: msaprofilePath,
    fullPath: msaprofilePath,
    cssRouteConfig: defaultCssPageConfig
  },
  myGames: {
    name: 'MyGames',
    path: 'mygames',
    fullPath: `${msaprofilePath}/mygames`,
    cssRouteConfig: defaultCssPageConfig
  },
  editSkin: {
    name: 'EditSkin',
    path: 'mygames/editskin',
    fullPath: `${msaprofilePath}/mygames/editskin`,
    cssRouteConfig: defaultCssPageConfig
  },
  editProfile: {
    name: 'EditProfile',
    path: 'mygames/editprofile',
    fullPath: `${msaprofilePath}/mygames/editprofile`,
    cssRouteConfig: defaultCssPageConfig
  },
  accountSettings: {
    name: 'AccountSettings',
    path: 'accountsettings',
    fullPath: `${msaprofilePath}/accountsettings`,
    cssRouteConfig: defaultCssPageConfig
  },
  redeem: {
    name: 'Redeem',
    path: 'redeem',
    fullPath: `${msaprofilePath}/redeem`,
    cssRouteConfig: {
      ...defaultCssPageConfig,
      breadcrumbs: false
    }
  },
  wallet: {
    name: 'Wallet',
    path: 'wallet',
    fullPath: walletFullPath,
    cssRouteConfig: defaultCssPageConfig
  },
  oneStoreWallet: {
    name: 'oneStoreWallet',
    path: 'myrealms',
    fullPath: oneStoreWalletFullPath,
    cssRouteConfig: {
      ...defaultCssPageConfig,
      pageBackgroundColor: 'purple'
    }
  },
  oneStoreRedeem: {
    name: 'oneStoreRedeem',
    path: 'redeem-code',
    fullPath: oneStoreRedeemFullPath,
    cssRouteConfig: defaultCssPageConfig
  },
  errorPage: {
    name: 'Error Page',
    path: `${msaprofilePath}/errorpage`,
    fullPath: '/errorpage',
    cssRouteConfig: defaultCssPageConfig
  },
  editRealmJava: {
    name: 'Java realm',
    path: 'mygames/java/realm',
    fullPath: (id: string) => `${msaprofilePath}/mygames/java/realm?realmid=${id}`,
    cssRouteConfig: {
      ...defaultCssPageConfig,
      pageBackgroundColor: 'gradient-purple'
    }
  },
  editRealmBedrock: {
    name: 'bedrock realm',
    path: 'mygames/bedrock/realm',
    fullPath: (id: string) => `${msaprofilePath}/mygames/bedrock/realm?realmid=${id}`,
    cssRouteConfig: {
      ...defaultCssPageConfig,
      pageBackgroundColor: 'gradient-purple'
    }
  }
} as const;

export default RouteList;
